import styles from './FJTextBaseEditingRightTop.module.less';

import FJUndoIcon from '../../../../assets/svg/undo.svg?react';
import FJRedoIcon from '../../../../assets/svg/redo.svg?react';
import FJToolTip from '../../../../common/components/FJToolTip/FJToolTip';
import FJPlayIcon from '../../../../assets/svg/timeline-play.svg?react';
import FJPauseIcon from '../../../../assets/svg/timeline-stop.svg?react';
import FJFitBox from '../../../../common/components/FJFitBox/FJFitBox';
import PropTypes from 'prop-types';
import FJUtil from '../../../../util/FJUtil';
import { useEffect, useCallback } from 'react';
import classNames from 'classnames';
import FJLocalStore from '../../../../store/FJLocalStore';

const FJTextBaseEditingRightTop = ({
    minUnitConversion,
    maxUnitConversion,
    changeUnitConversion,
    unitConversion,
    currentTime,
    totalTime,
    fitOnClickHandler,
    togglePlayPauseHandler,
    isPlaying,
    undo,
    redo,
    hasUndo,
    hasRedo,
}) => {
    const handleKeyDown = useCallback(
        e => {
            if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key.toLowerCase() === 'z') {
                hasRedo && redo();
                return;
            }
            if (e.ctrlKey || e.metaKey) {
                switch (e.key) {
                    case 'z':
                        hasUndo && undo();
                        break;
                    case 'y':
                        hasRedo && redo();
                        break;
                    default:
                        break;
                }
            } else if (e.key === ' ' || e.key === 'Space') {
                e.stopPropagation();
                e.preventDefault();
                togglePlayPauseHandler();
            }
        },
        [togglePlayPauseHandler, hasUndo, hasRedo, undo, redo],
    );

    useEffect(() => {
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleKeyDown]);

    return (
        <div className={styles.container}>
            <div className={styles.undo_redo_box}>
                <FJToolTip title={FJLocalStore._('undo')}>
                    <div
                        className={classNames(styles.undo_item, {
                            [styles.disabled]: !hasUndo,
                        })}
                        onClick={undo}
                    >
                        <FJUndoIcon />
                    </div>
                </FJToolTip>
                <FJToolTip title={FJLocalStore._('redo')}>
                    <div
                        className={classNames(styles.redo_item, {
                            [styles.disabled]: !hasRedo,
                        })}
                        onClick={redo}
                    >
                        <FJRedoIcon />
                    </div>
                </FJToolTip>
            </div>

            <div className={styles.time_box}>
                <div className={styles.play_btu} onClick={togglePlayPauseHandler}>
                    {isPlaying ? <FJPauseIcon /> : <FJPlayIcon />}
                </div>
                <div className={styles.time_current}>{FJUtil.formatTime(currentTime, true)}</div>
                <div className={styles.time_all}> / {FJUtil.formatTime(totalTime, true)}</div>
            </div>

            <FJFitBox
                maxZoom={maxUnitConversion}
                minZoom={minUnitConversion}
                zoom={unitConversion}
                onChangeZoom={changeUnitConversion}
                fitOnClickHandler={fitOnClickHandler}
                step={minUnitConversion}
                placement='top'
                zoomOutDisabled={unitConversion <= minUnitConversion}
                zoomInDisabled={unitConversion >= maxUnitConversion}
            />
        </div>
    );
};

FJTextBaseEditingRightTop.propTypes = {
    minUnitConversion: PropTypes.number.isRequired,
    maxUnitConversion: PropTypes.number.isRequired,
    changeUnitConversion: PropTypes.func.isRequired,
    unitConversion: PropTypes.number.isRequired,
    currentTime: PropTypes.number.isRequired,
    totalTime: PropTypes.number.isRequired,
    fitOnClickHandler: PropTypes.func.isRequired,
    togglePlayPauseHandler: PropTypes.func.isRequired,
    isPlaying: PropTypes.bool.isRequired,
    undo: PropTypes.func.isRequired,
    redo: PropTypes.func.isRequired,
    hasUndo: PropTypes.bool.isRequired,
    hasRedo: PropTypes.bool.isRequired,
};

export default FJTextBaseEditingRightTop;
